<template>
  <div>
    
    <!-- Filter -->
    <!-- <AttachmentsFilter :atSearch="onSearch" :atFormReset="onFormReset" v-model="searchModel" :docTypes="docTypes" /> -->

    <!-- Upload Button -->
    <div class="md-layout md-alignment-center-right">
      <md-button 
        class="md-raised md-primary" 
        @click="onUpload" 
        style="margin: 15px 0 0 0;"
      >Upload</md-button>
    </div>

    <!-- List -->
    <ElasticList :list="list" :filter="filter" ref="attachmentsListRef" :atOpenPopup="onOpenPopup" ></ElasticList>

    <!-- Upload Dialog -->
    <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
      <md-dialog-title>Attachment</md-dialog-title>
      <md-dialog-content>
        <AttachmentsForm
          :docTypes="docTypes"
          :model="activeModel"
          :relations="relations"
          :isDeleteDisabled="isDeleteDisabled"
          @success="onUploadSuccess" 
        />
      </md-dialog-content>
    </md-dialog>
    
    <!-- Remove confirmation dialog -->
    <md-dialog-confirm
      style="width: 360px;"
      :md-active.sync="confirmDialog.isOpen"
      :md-title="confirmDialog.title"
      :md-content="confirmDialog.content"
      md-confirm-text="Yes"
      md-cancel-text="Cancel"
      @md-cancel="resetRemoveDialog"
      @md-confirm="remove"
    />

  </div>
</template>

<script>
  import _ from "lodash";
  import moment from "moment";
  import Amplify, { Auth, API, graphqlOperation, JS } from "aws-amplify";
  import * as queries from "@/graphql/queries";
  import * as queries_custom from "@/graphql/queries_custom";
  import * as mutations from '@/graphql/mutations';

  import ElasticList from '@/components/DynamicForm/ElasticList';
  import AttachmentsFilter from '@/components/DynamicForm/Attachments/AttachmentsFilter';
  import AttachmentsForm from '@/components/DynamicForm/Attachments/AttachmentsForm';
  import AttachmentsConfig from '@/components/DynamicForm/Attachments/AttachmentsConfig';

  export default {
    name: 'Attachments',
    mixins: [],
    components: {
      ElasticList,
      AttachmentsFilter,
      AttachmentsForm,
    },
    props: {
      filter: {
        type: [Array, Object],
        required: false
      },
      relations: {
        type: Array,
        required: true,
      },
      isDeleteDisabled: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        list: AttachmentsConfig(this),
        activeModel: {},
        searchModel: {},
        isUploadDialogOpen: false,
        docTypes: [],
        confirmDialog: {
          isOpen: false,
          content: '',
          title: '',
          item: null,
        },
      };
    },
    async mounted() {
      this.docTypes = await this.getDocTypes();
      window.$bus.$on("side-bar-tab-changed", (tabId) => {
        if(tabId === "attachments" || tabId === 'service-attachments') {
          if (this.$refs.attachmentsListRef) {
            setTimeout( () => {
              this.$refs.attachmentsListRef.refresh();
            }, 1000)
          }
        }
      })
    },
    methods: {
      /**
       * Search attachments
       * @returns {Void}
       */
      onSearch() {
        if(this.isUploadDialogOpen){
          this.isUploadDialogOpen = false;
        }
        if (this.$refs.attachmentsListRef) {
          this.$refs.attachmentsListRef.refresh();
        }
      },
      /**
       * Reset filter form model
       * @return {void}
       */
      onFormReset() {
        this.$set(this, 'searchModel', {
          query: null,
          type: null,
        });

        this.$refs.attachmentsListRef.refresh();
      },
      /**
       * Show attachment upload form
       * @returns {Void}
       */
      onUpload() {
        this.$set(this, 'activeModel', {});
        this.isUploadDialogOpen = true;
      },
      /**
       * Attachment was successfully added or updated
       * Close dialog
       * @returns {Void}
       */
      onUploadSuccess() {
        this.isUploadDialogOpen = false;
        this.onSearch();
      },
      /**
       * Get attachment Types Enum
       * @returns {Array} array of objects holding enum options
       */
      getDocTypes() {
        return new Promise((resolve, reject) => {
          let operation = graphqlOperation(queries_custom.listAttachmentTypeEnum, { limit: 999 });
          API.graphql(operation)
            .then(response => {
              let values = this.$reduce(response, 'data.listAttachmentTypeEnum.enumValues');
              let options = [];
              for (const _value of values) {
                options.push({
                  id: _value.name,
                  label: _value.name.replace(/_/ig, ' '),
                });
              }
              resolve(options);
            })
            .catch(err => {
              console.log('getDocTypes - Error', err);
              resolve([]);
            });
        });
      },
      /**
       * Edit an attachment
       * @param {Object} item - attachment relation item
       * @returns {Void}
       */
      onEdit(item) {
        this.$set(this, 'activeModel', item);
        this.isUploadDialogOpen = true;
      },
      /**
       * Remove an attachment
       * @param {Object} item - attachment relation item
       * @returns {Void}
       */
      onRemove(item) {
        const name = this.$reduce(item, 'attachment.name');
        this.confirmDialog.item = item;
        this.confirmDialog.title = `Are you sure you want to remove ${name}?`
        this.confirmDialog.content =  `The change cannot be undone.`;
        this.confirmDialog.isOpen = true;
      },
      /**
       * Reset remove dialog options
       * @returns {Void}
       */
      resetRemoveDialog() {
        this.confirmDialog.item = null;
        this.confirmDialog.title = '';
        this.confirmDialog.content = '';
        this.confirmDialog.isOpen = false;
      },
      /**
       * Remove all relations of the attachment
       * @returns {Void}
       */
      async remove() {
        let error = null;
        // search for all relations of the attachment
        const searchQuery = graphqlOperation(queries.searchRelations, {
          filter: {
            relationAttachmentId: { eq: this.confirmDialog.item.id },
          },
        });
        const searchResponse = await API.graphql(searchQuery).catch(err => error = err);
        if (error) {
          console.log('Error searching relations on remove operation', error);
          return;
        }
        // delete all relations
        const promises = [];
        const items = searchResponse.data.searchRelations.items;
        for (let i = 0; i < items.length; i++) {
          const deleteMutation = graphqlOperation(mutations.deleteRelation, {
            input: { id: items[i].id },
          });
          promises.push(API.graphql(deleteMutation));
        }
        Promise.all(promises)
          .then(() => {
            // setting timeout to make sure all associated records get removed
            setTimeout(() => this.onSearch(), 1000);
          })
          .catch(err => {
            console.log('Error removing relations on remove operation', err);
          });
      },
      onOpenPopup() {
      },
    }
  };
</script>

<style lang="scss">
</style>
